// import React, { useState, useEffect } from "react";
// import './css/codeEditor.css';
import copy_icon from "../../data/images/img-copy.png";
import { Editor, EditorState, RichUtils, convertToRaw, convertFromRaw, Modifier } from "draft-js";
import "draft-js/dist/Draft.css";
import { useEffect, useState } from 'react';


const TextView = (props) => {

  const [content , setContent] = useState(props.data.d.source);
  const [editorState , setEditorState] = useState(EditorState.createEmpty());
  const [editorStateFreez , seteditorStateFreez] = useState(EditorState.createEmpty());

  useEffect(
    ()=>{
      let dummy = props.data.d.source;
      if (dummy !== null & dummy[0]==="{" ){
        //the json is ok
        console.log("Json Ok");
        const rawEditorData = JSON.parse(dummy);
      if (rawEditorData !== null) {
        const contentState = convertFromRaw(rawEditorData);
        seteditorStateFreez(EditorState.createWithContent(contentState));
      }
      }else{
        //the json is not ok
        let contentState = editorState.getCurrentContent();
        let targetRange = editorState.getSelection();
        let newContentState = Modifier.insertText(
          contentState,
          targetRange,
          dummy
        );
        // const new_contentState = convertFromRaw(newContentState);
        seteditorStateFreez(EditorState.createWithContent(newContentState));

        // console.log("Dummy",newContentState);
    }
    },[])

  const Copy_btn = () => {
    // Copy to Clipbord Button
    console.log("button Display clicked");
    var input = document.createElement('input');
    // var value  = this.state.open_topic.cells[index].source;
    var value  = editorStateFreez.getCurrentContent().getPlainText();
    input.setAttribute('value', value);
    document.body.appendChild(input);
    input.select();
    var result = document.execCommand('copy');
    document.body.removeChild(input);
    return result;
};
  
  return (
    <div >
      <button className="copy_button" onClick={Copy_btn.bind()}>
          {/* <span class="copy-tooltip">Copy Text</span> */}
          <img className="copy_icon" src={copy_icon}></img>
      </button>
      <div className="display-text">
      <Editor editorState={editorStateFreez} readOnly />
        {/* {props.data.d.source} */}
      </div>
    </div>
  );
};

export default TextView;